import devConfig from './dev';
import prodConfig from './prod';

// to switch from one environment to the other way:
// on Terminal: NODE_ENV=production   or   NODE_ENV=development

const isDev = process.env.NODE_ENV === "development";
const config = isDev ? devConfig : prodConfig;

export default config;